import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as emptyStar } from '@fortawesome/free-regular-svg-icons'
import { useDispatch } from 'react-redux'
import { getJobScreenings } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import { updateJobApplication } from 'store/Recruitment/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const ratingLabels = ['Poor', 'Fair', 'Good', 'Excellent', 'WOW']

function Rating() {
  const dispatch = useDispatch()
  const location = useLocation()

  const { jobScreenings, jobApplication } = useSelector(
    (store) => store.recruitment
  )

  const emptyStars = Array.from({ length: 5 }, (_, i) => i)

  const [rating, setRating] = useState(0)
  const [permRating, setPermRating] = useState(0)

  useEffect(() => {
    dispatch(getJobScreenings())
  }, [dispatch])

  const answers =
    jobApplication && jobApplication?.answers
      ? JSON.parse(jobApplication?.answers)
      : []

  useEffect(() => {
    if (jobApplication?.rating) {
      setPermRating(jobApplication?.rating)
      setRating(jobApplication?.rating)
    }
  }, [jobApplication?.rating])

  return (
    <div
      className='d-flex align-items-start justify-content-between'
      style={{ gap: '2rem' }}
    >
      <Card className='w-50'>
        <CardHeader className='title'>Rating details</CardHeader>
        <CardBody>
          <div
            onMouseLeave={() => setRating(permRating)}
            className='d-flex align-items-center'
            style={{ gap: '0.5rem' }}
          >
            {emptyStars.map((star, i) => {
              const label = ratingLabels[i] || ''
              const isFilled = i + 1 <= rating

              return (
                <div
                  key={i}
                  className='star-wrapper'
                  style={{ position: 'relative' }}
                >
                  <FontAwesomeIcon
                    icon={isFilled ? faStar : emptyStar}
                    className='text-warning'
                    size='2xl'
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={() => setRating(i + 1)}
                    onClick={() => {
                      setPermRating(i + 1)
                      dispatch(
                        updateJobApplication(
                          location?.search?.split('=')?.at(1),
                          { rating: i + 1 }
                        )
                      )
                    }}
                  />
                  <span className='tooltip-text'>{label}</span>
                </div>
              )
            })}
          </div>
        </CardBody>
      </Card>
      <Card className='w-50'>
        <CardHeader className='title'>Question & Answer</CardHeader>
        <CardBody>
          {jobScreenings?.map((question) => (
            <div key={question?.id} className='d-flex flex-column mb-3'>
              <span className='font-weight-bold' style={{ fontSize: '16px' }}>
                {question?.question}
              </span>
              <span className=''>
                {answers?.find((answer) => answer?.id === question?.id)
                  ?.answer ?? '-'}
              </span>
            </div>
          ))}
        </CardBody>
      </Card>
    </div>
  )
}

export default Rating
